import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { OrderService } from 'src/app/core/services/order.service';
import { CarConfiguratorComponent } from 'src/app/shared/components/car-configurator/car-configurator.component';
import { StockVehiclesComponent } from 'src/app/shared/components/stock-vehicles/stock-vehicles.component';
import { UseOptions, FuelType } from 'src/app/shared/model/didactic.enum';
import { LoanOptions } from 'src/app/shared/model/loanRequest.enum';
import {
  CarpoolCenterDateData,
  ModelList
} from 'src/app/shared/model/order.model';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { PccVehicle, Vehicles } from 'src/app/shared/model/vehicle.model';
import { ModalErrorConfigComponent } from './modal-error-config/modal-error-config.component';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { CoreService } from 'src/app/core/services/core.service';
import { StorageService } from 'src/app/core/storage/storage.service';
import { MatIconModule } from '@angular/material/icon';
import { VehiclesService } from 'src/app/core/services/vehicles.service';
import { MatOptionSelectionChange } from '@angular/material/core';
import { FeedbackModalComponent } from '../../../feedback-modal/feedback-modal.component';

@Component({
  standalone: true,
  selector: 'app-step-car-config',
  templateUrl: './step-car-config.component.html',
  styleUrls: ['./step-car-config.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    I18NextModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule,
    MatStepperModule,
    MatInputModule,
    MatCheckboxModule,
    CarConfiguratorComponent,
    StockVehiclesComponent,
    CdkStepperModule,
    MatIconModule
  ]
})
export class StepCarConfigComponent implements OnInit {
  @Input() requestType!: string;
  @Input() isDetail!: boolean;
  @Input() modelList?: ModelList[];
  @Input() loanType?: string;
  @Input() totalDays?: number;
  @Input() carPoolCenterDate?: CarpoolCenterDateData;
  @Input() stepper!: MatStepper;

  @Output() updateVehicleInfoDataEmitter = new EventEmitter<
    PccVehicle | Vehicles
  >();
  @Output() backStepEmitter = new EventEmitter();
  @ViewChild(CarConfiguratorComponent) carConfComp?: CarConfiguratorComponent;

  vehicleInfoData?: PccVehicle;
  stockVehicle?: Vehicles;
  configCode!: string;
  useOptionsEnum = Object.values(UseOptions);
  fuelTypeEnum = Object.values(FuelType);
  requestTypeEnum = RequestType;
  configuratorText = '';
  modelListSelected: string[] = [];
  stockText = '';
  stockVin = false;
  loanOptions = LoanOptions;
  stockModel = false;
  selectedModel?: ModelList;
  valueText = '';
  selectedQuota?: number;
  newVehicle: any;
  vehicles: any;
  //errores
  quotaError = false;
  errorPcc = false;
  modelError = false;
  useError = false;
  fuelError = false;
  //forms
  configCarform: FormGroup = this.fb.group({});
  educationalForm: FormGroup = this.fb.group({});
  generalServicesForm: FormGroup = this.fb.group({});
  innerRouteForm: FormGroup = this.fb.group({});
  loanForm: FormGroup = this.fb.group({});
  optionalCodes: string[] = [];
  extensionCodes: string[] = [];
  optionalDescriptions: string[] = [];
  extensionDescriptions: string[] = [];
  isVip = false;
  landing2 = false;
  maxQuota = 0;
  vehicleInfoVip = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private orderService: OrderService,
    private coreService: CoreService,
    private storageService: StorageService,
    private vehicleService: VehiclesService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    if (
      this.storageService.get('config') &&
      this.storageService.get('requestCarType')
    ) {
      this.isVip =
        ['PRESI', 'VICE', 'TMK'].includes(
          this.storageService.get('config').category
        ) &&
        this.storageService.get('requestCarType') ===
          'endowmentLeasingEndowment';
    }
    if (this.requestType === this.requestTypeEnum.didactic) {
      this.educationalForm = this.fb.group({
        model: ['', [Validators.required]],
        use: ['', [Validators.required]],
        propulsion: ['', [Validators.required]],
        reason: ['', [Validators.required]],
        specifications: ['', [Validators.required]]
      });
    } else if (this.requestType === this.requestTypeEnum.innerRoute) {
      this.innerRouteForm = this.fb.group({
        model: [, [Validators.required]]
      });
    } else if (this.requestType === this.requestTypeEnum.loan) {
      this.loanForm = this.fb.group({
        model: ['', [Validators.required]],
        quota: []
      });
    } else {
      if (this.requestType === this.requestTypeEnum.generalServices) {
        this.configCarform = this.fb.group({
          type: ['newFabric', [Validators.required]],
          subtype: ['configVehicle']
        });

        this.configCarform.get('type')?.valueChanges.subscribe(() => {
          if (this.configCarform.get('type')?.value !== 'newFabric') {
            this.configCarform.get('subtype')?.setValue('');
          } else {
            this.configCarform.get('subtype')?.setValue('configVehicle');
          }
          this.modelListSelected = [];
        });
      } else {
        this.configCarform = this.fb.group({
          type: ['configurator', [Validators.required]]
        });
      }
    }
  }

  carConfigInfoUpdadte(data: PccVehicle) {
    this.vehicleInfoData = data;
    this.stockVehicle = undefined;
  }

  updateCodeConfig(code: string) {
    this.configCode = code;
  }

  changeUse() {
    this.educationalForm.controls['use'].dirty &&
    this.educationalForm.value.use === ''
      ? (this.useError = true)
      : (this.useError = false);
  }

  changeFuel() {
    this.educationalForm.controls['propulsion'].dirty &&
    this.educationalForm.value.propulsion === ''
      ? (this.fuelError = true)
      : (this.fuelError = false);
  }

  setFuelTypeText(option: string) {
    if (option === 'H') {
      return i18next.t('hybrid');
    } else if (option === 'E') {
      return i18next.t('electric');
    } else {
      return i18next.t('combustion');
    }
  }

  exceededQuota(exceededQuota: boolean) {
    this.quotaError = exceededQuota;
  }

  updateErrorPcc(error: boolean) {
    this.errorPcc = error;
  }

  showVehicleInfo(info: boolean) {
    this.vehicleInfoVip = info;
  }

  onStockVehicleChange(vehicle: any) {
    this.stockVehicle = vehicle;
    this.vehicleInfoData = undefined;
    this.requestType === this.requestTypeEnum.loan
      ? (this.stockVin = true)
      : (this.stockVin = false);
  }

  changeStockModel() {
    if (
      this.loanForm.controls['model'].dirty &&
      this.loanForm.value.model === 'empty' &&
      this.loanType !== this.loanOptions.CP
    ) {
      this.modelError = true;
    } else if (
      this.loanForm.controls['model'].dirty &&
      this.loanForm.value.model === 'empty'
    ) {
      this.stockModel = false;
    } else {
      this.modelError = false;
      this.selectedModel = this.modelList?.find(
        (model) => model.name === this.loanForm.value.model
      );
      this.stockModel = true;
    }
  }

  updateLoanQuota(option: MatOptionSelectionChange) {
    if (option.isUserInput) {
      const loanQuota = option.source.value.loanQuota;
      this.selectedQuota = loanQuota;
      if (this.totalDays) {
        this.valueText = `${Math.trunc(this.totalDays)} ${i18next.t('days')} / ${loanQuota * this.totalDays}${i18next.t('euro')}`;
      }
    }
  }

  changeModel(data: string) {
    const existElement = this.modelListSelected.find(
      (item: string) => item === data
    );
    if (existElement) {
      this.modelListSelected = this.modelListSelected.filter(
        (item: string) => item !== data
      );
    } else {
      this.modelListSelected.push(data);
    }
  }

  getFormattedDescriptions(): string {
    if (
      this.vehicleInfoData?.optionals &&
      this.vehicleInfoData?.optionals.length > 0
    ) {
      return this.vehicleInfoData.optionals
        .map((optional: any) => optional.description)
        .join(' / ');
    }
    return '';
  }

async nextStep(callbackData?: any) {
    console.log('==============================================');
  console.log('[PADRE nextStep] DATO RECIBIDO DEL HIJO:', callbackData);
  console.log('[PADRE nextStep] ¿HA VENIDO DATO?:', callbackData !== undefined);
  console.log('========== nextStep ==========');
  console.log('[nextStep] requestType:', this.requestType);
  console.log('[nextStep] isVip:', this.isVip);
  console.log('[nextStep] callbackData:', callbackData);
  console.log('[nextStep] configCarform.value:', this.configCarform?.value);
  console.log('[nextStep] vehicleInfoData inicial:', this.vehicleInfoData);
  console.log('[nextStep] configCode inicial:', this.configCode);

  if (this.requestType === this.requestTypeEnum.didactic) {

    console.log('[nextStep] Rama: didactic');
    console.log('[nextStep] educationalForm.value:', this.educationalForm.value);

    this.newVehicle = {
      ...this.educationalForm.value
    };

  } else if (this.requestType === this.requestTypeEnum.generalServices) {

    console.log('[nextStep] Rama: generalServices');
    console.log('[nextStep] type:', this.configCarform.value.type);
    console.log('[nextStep] subtype:', this.configCarform.value.subtype);

    if (
      this.configCarform.value.type === 'newFabric' &&
      this.configCarform.value.subtype === 'stock'
    ) {
      console.log('[nextStep] generalServices -> newFabric / stock');
      console.log('[nextStep] stockVehicle:', this.stockVehicle);

      this.vehicles = this.stockVehicle;

    } else if (
      this.configCarform.value.type === 'newFabric' &&
      this.configCarform.value.subtype === 'configVehicle'
    ) {
      console.log('[nextStep] generalServices -> newFabric / configVehicle');
      console.log('[nextStep] Llamando getConfiguration()...');

      await this.getConfiguration(callbackData);

      console.log('[nextStep] getConfiguration() terminado');
      console.log('[nextStep] vehicleInfoData:', this.vehicleInfoData);
      console.log('[nextStep] configCode:', this.configCode);

      this.vehicles = this.vehicleInfoData;
      this.configCode = '';

    } else {
      console.log('[nextStep] generalServices -> modelListSelected');
      console.log('[nextStep] modelListSelected:', this.modelListSelected);

      this.vehicles = this.modelListSelected;
    }

    this.newVehicle = {
      type: this.configCarform.value.type,
      data: this.vehicles,
      configCode: this.configCode
    };

  } else if (this.requestType === this.requestTypeEnum.innerRoute) {

    console.log('[nextStep] Rama: innerRoute');
    console.log('[nextStep] innerRouteForm.value:', this.innerRouteForm.value);

    this.newVehicle = {
      model: this.innerRouteForm.value.model
    };

  } else if (this.requestType === this.requestTypeEnum.loan) {

    console.log('[nextStep] Rama: loan');
    console.log('[nextStep] loanType:', this.loanType);

    if (this.loanType === this.loanOptions.CP) {
      console.log('[nextStep] loan -> CP');
      console.log('[nextStep] stockVehicle:', this.stockVehicle);

      this.newVehicle = {
        VIN: this.stockVehicle?.VIN
      };

    } else {
      console.log('[nextStep] loan -> no CP');
      console.log('[nextStep] loanForm.value:', this.loanForm.value);
      console.log('[nextStep] selectedQuota:', this.selectedQuota);

      this.newVehicle = {
        model: this.loanForm.value.model.name,
        quota: this.selectedQuota
      };
    }

  } else if (
    this.requestType === this.requestTypeEnum.dotArr ||
    this.requestType === this.requestTypeEnum.leasing
  ) {

    console.log('[nextStep] Rama: dotArr / leasing');
    console.log('[nextStep] requestType:', this.requestType);
    console.log('[nextStep] isVip:', this.isVip);
    console.log('[nextStep] callbackData recibido:', callbackData);

    if (!this.isVip) {
      console.log('[nextStep] No VIP -> llamando getConfiguration()...');

      await this.getConfiguration(callbackData);

      console.log('[nextStep] getConfiguration() terminado');
      console.log('[nextStep] vehicleInfoData:', this.vehicleInfoData);
      console.log('[nextStep] configCode:', this.configCode);
    } else {
      console.log('[nextStep] VIP -> NO se llama getConfiguration()');
    }

    this.newVehicle = {
      type: this.configCarform.value.type,
      data: this.vehicleInfoData,
      configCode: this.configCode
    };

  } else if (this.requestType === this.requestTypeEnum.function) {

    console.log('[nextStep] Rama: function');
    console.log('[nextStep] type:', this.configCarform.value.type);

    if (this.configCarform.value.type === 'stock') {

      console.log('[nextStep] function -> stock');
      console.log('[nextStep] stockVehicle:', this.stockVehicle);

      this.newVehicle = {
        type: this.configCarform.value.type,
        data: this.stockVehicle,
        configCode: this.configCode
      };

    } else {

      console.log('[nextStep] function -> configuration');
      console.log('[nextStep] Llamando getConfiguration()...');

      await this.getConfiguration(callbackData);

      console.log('[nextStep] getConfiguration() terminado');
      console.log('[nextStep] vehicleInfoData:', this.vehicleInfoData);
      console.log('[nextStep] configCode:', this.configCode);

      this.newVehicle = {
        type: this.configCarform.value.type,
        data: this.vehicleInfoData,
        configCode: this.configCode
      };
    }

  } else {

    console.log('[nextStep] Rama: else/default');
    console.log('[nextStep] type:', this.configCarform.value.type);
    console.log('[nextStep] stockVehicle:', this.stockVehicle);
    console.log('[nextStep] vehicleInfoData:', this.vehicleInfoData);

    this.newVehicle = {
      type: this.configCarform.value.type,
      data:
        this.configCarform.value.type === 'stock'
          ? this.stockVehicle
          : this.vehicleInfoData,
      configCode: this.configCode
    };
  }

  console.log('[nextStep] newVehicle FINAL:', this.newVehicle);
  console.log('[nextStep] quotaError:', this.quotaError);

  if (!this.quotaError) {
    console.log('[nextStep] EMIT updateVehicleInfoDataEmitter:', this.newVehicle);

    this.updateVehicleInfoDataEmitter.emit(this.newVehicle);
  } else {
    console.warn('[nextStep] No se emite porque quotaError = true');
  }

  console.log('========== /nextStep ==========');
}
  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.landing2
        ? this.backStepEmitter.emit()
        : this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }

  async getConfiguration(callbackData?: any) {//ENVIAR AQUI EL CODIGO


    const res = await firstValueFrom(this.orderService.getConfiguration(callbackData.seatCode, callbackData.context));//CRMSP-8547
    
    if (this.isDateOlderThanMinutes(new Date(res.carConfigDate))) {
      this.dialog.open(ModalErrorConfigComponent);
      throw Error;
    }
    this.errorPcc = false;
    this.vehicleInfoData = res;
    this.vehicleInfoData.country = this.vehicleInfoData.country || 'es';
    if (this.requestType === this.requestTypeEnum.leasing) {
      await this.getLeasingRetribution(this.vehicleInfoData!.tmaimg);
      this.vehicleInfoData.model = this.vehicleService.getModelByTmaimg(
        this.vehicleInfoData!.tmaimg
      );
      this.vehicleInfoData.fuelType =
        this.vehicleService.getCombustibleByTmaimg(
          this.vehicleInfoData!.tmaimg
        );
    }

    const quota = this.vehicleInfoData.prices.fee
      ? this.getValor(this.vehicleInfoData.prices.fee)
      : 0;

    if (
      quota > this.maxQuota &&
      this.requestType === this.requestTypeEnum.function
    ) {
      const dialogRef = this.dialog.open(FeedbackModalComponent, {
        width: '400px',
        data: {
          text: i18next.t('errorExCuota'),
          close: true,
          theme: 'ligth'
        }
      });
      this.quotaError = true;

      dialogRef.afterClosed().subscribe(() => {
        // Emitir un evento al componente hijo o llamar a un método directamente
        if (this.carConfComp) {
          this.carConfComp.reconnectWebSocket();
        }
      });
    } else {
      this.quotaError = false;
    }
    await this.translateOptionalsAndExtensions(
      !!res.optionalsCodes ? res.optionalsCodes.split(';') : [],
      !!res.extensionsCodes ? res.extensionsCodes.split(';') : []
    );
  }

  isDateOlderThanMinutes(date: Date): boolean {
    const offset = Math.abs(new Date(Date.now()).getTimezoneOffset()) + 5;
    const minutesAgo = new Date(Date.now() - offset * 60 * 1000);
    return date < minutesAgo;
  }

  async translateOptionalsAndExtensions(
    optionalCodes: string[],
    extensionCodes: string[]
  ) {
    if (!!this.vehicleInfoData && !this.vehicleInfoData.descExtColor) {
      optionalCodes.push(this.vehicleInfoData.extColor);
    }
    if (!!this.vehicleInfoData && !this.vehicleInfoData.descIntColor) {
      optionalCodes.push(this.vehicleInfoData.intColor.trim().slice(-2));
    }
    const [optionalDescriptions, extensionDescriptions] = await Promise.all([
      firstValueFrom(this.coreService.getDescOptionals(optionalCodes)),
      firstValueFrom(this.coreService.getDescOptionals(extensionCodes))
    ]);
    if (!!this.vehicleInfoData) {
      if (!this.vehicleInfoData.descIntColor) {
        const descIntColor = optionalDescriptions.pop();
        this.vehicleInfoData.descIntColor = !!descIntColor ? descIntColor : '';
      }
      if (!this.vehicleInfoData.descExtColor) {
        const descExtColor = optionalDescriptions.pop();
        this.vehicleInfoData.descExtColor = !!descExtColor ? descExtColor : '';
      }
      this.vehicleInfoData.descriptionOptionalCodes = optionalDescriptions;
      this.vehicleInfoData.descriptionExtensionsCodes = extensionDescriptions;
    }
  }

  getValor(texto: string): number {
    if (texto.includes(',')) {
      const parsedValue = parseFloat(texto.replace(',', '.').trim());
      return parsedValue;
    }
    return parseFloat(texto.trim());
  }

  async getLeasingRetribution(tmaimg: string) {
    await firstValueFrom(this.vehicleService.getLeasingRetribution(tmaimg))
      .then((resp) => {
        if (!!this.vehicleInfoData) {
          this.vehicleInfoData.prices.leasingRE = resp;
        }
      })
      .catch(() => {
        if (!!this.vehicleInfoData) {
          this.vehicleInfoData.prices.leasingRE = '0';
        }
      });
  }

  getMaxQuota(maxQuota: number) {
    this.maxQuota = maxQuota;
  }
}
